module.exports = __webpack_public_path__ + "static/media/Pebble.6fd1da41.ttf";